import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const KeyIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      d="M21.167 19h-5.5v-3.714H13.21A6.41 6.41 0 0 1 7.417 19C3.878 19 1 16.084 1 12.5S3.878 6 7.417 6c2.493 0 4.739 1.467 5.793 3.714H23v5.572h-1.833zM17.5 17.143h1.833v-3.714h1.834V11.57h-9.222l-.21-.622c-.643-1.848-2.384-3.092-4.318-3.092-2.53 0-4.584 2.08-4.584 4.643s2.054 4.643 4.584 4.643c1.934 0 3.675-1.244 4.317-3.092l.211-.622H17.5zM7.417 15.286c-1.513 0-2.75-1.254-2.75-2.786s1.237-2.786 2.75-2.786 2.75 1.254 2.75 2.786-1.238 2.786-2.75 2.786m0-3.715a.925.925 0 0 0-.917.929c0 .51.412.929.917.929a.925.925 0 0 0 .916-.929.925.925 0 0 0-.916-.929"
    />
  </BaseIcon>
)
